export default __webpack_public_path__ + "static/media/screen3.b45202fe.jpg";